export default "__VITE_ASSET__d7850bd0__"